<template>
	<div class="ce-headline">
		<div
			class="ce-headline"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value, objectdata.headlinecentered)"
		/>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
</style>